import { render, staticRenderFns } from "./pagoVocal.vue?vue&type=template&id=41bfab6a&scoped=true"
import script from "./pagoVocal.vue?vue&type=script&lang=js"
export * from "./pagoVocal.vue?vue&type=script&lang=js"
import style0 from "./pagoVocal.vue?vue&type=style&index=0&id=41bfab6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bfab6a",
  null
  
)

export default component.exports